module.exports = __webpack_public_path__ + "img/cuhk_emblem.2ea1c694.png";